import React, { useState, useEffect, useContext } from 'react';
import { useForm } from 'react-hook-form';
import { json, Link, useNavigate } from 'react-router-dom';
import toast from "react-hot-toast";
import AppContext from "../context/AppContext";
import Signals from "../assets/svg/signals-icon.svg";

const AdminCTFlix = () => {
  const navigate = useNavigate();
  const { loading, updateLoading } = useContext(AppContext);
  const { register, handleSubmit, setValue, watch, reset, formState: { errors }, } = useForm();
  const [tokenSearch, setTokenSearch] = useState([]);
  const [data, setData] = useState([]);
  const [imageUrl, setImageUrl] = useState('');
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(100);
  const [total, setTotal] = useState(0);
  const [videos, setVideos] = useState([]);
  const [groupedByLanguage, setGroupedByLanguage] = useState({});
  const [expandedGroups, setExpandedGroups] = useState({});

  // Función para manejar el estado de los grupos colapsables
  const toggleGroup = (groupKey) => {
    setExpandedGroups((prev) => ({
      ...prev,
      [groupKey]: !prev[groupKey],
    }));
  };



  const onSubmit = async (data) => {
    updateLoading(true);
    const formData = new FormData();
    formData.append("type", data.type);
    formData.append("module", data.module);
    formData.append("vimeo", data.vimeo);
    formData.append("name", data.name);
    formData.append("description", data.description);
    formData.append("language", data.language);
    fetch(`${process.env.REACT_APP_BACKEND}/ctflix`, {
      method: "POST",
      headers: {
        Authorization: `${localStorage.getItem("token")}`,
      },
      body: formData,
    })
      .then((response) => response.json())
      .then((response) => {
        if (!response.status) {
          toast.error("Error al crear video");
          updateLoading(false);
        } else {
          toast.success("Se agrego el video con exito");
          getAllAdmin();
          reset();
          updateLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        updateLoading(false);
      });
  };


  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      // Suponiendo que el endpoint para subir la imagen es "https://your-api-endpoint.com/upload"
      const formData = new FormData();
      formData.append('file', file);

      try {
        const response = await fetch('https://your-api-endpoint.com/upload', {
          method: 'POST',
          body: formData,
        });
        const result = await response.json();
        if (result.url) {
          setImageUrl(result.url); // Asumiendo que el resultado es una URL
        }
      } catch (error) {
        console.error('Error al subir la imagen', error);
      }
    }
  };


  useEffect(() => {
    getAllAdmin();
  }, [page, limit]);



  const getAllAdmin = async () => {
    updateLoading(true);
    fetch(`${process.env.REACT_APP_BACKEND}/ctflix-admin?page=${page}&limit=${limit}`, {
      method: "GET",
      headers: {
        Authorization: `${localStorage.getItem("token")}`,
      },
    })
      .then((response) => response.json())
      .then((response) => {
        if (!response.status) {
          if (response.redirect) {
            navigate("/");
          }
          updateLoading(false);
        } else {
          setVideos(response?.data?.items || []);
          updateLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        updateLoading(false);
      });
  };

  useEffect(() => {
    const grouped = {};

    videos.forEach((video) => {
      if (video.language) {
        // Agrupar por idioma (language)
        if (!grouped[video.language]) {
          grouped[video.language] = {};
        }

        // Agrupar por tipo (type) dentro de cada idioma
        if (!grouped[video.language][video.type]) {
          grouped[video.language][video.type] = {};
        }

        // Agrupar por módulo (module) dentro de cada tipo
        if (video.module && !grouped[video.language][video.type][video.module]) {
          grouped[video.language][video.type][video.module] = [];
        }

        // Asignar el video a la estructura del agrupamiento
        if (video.module) {
          grouped[video.language][video.type][video.module].push(video);
        } else {
          // Si no tiene módulo, asignarlo en el tipo correspondiente
          grouped[video.language][video.type]["Sin módulo"].push(video);
        }
      }
    });
    console.log(grouped)
    setGroupedByLanguage(grouped);
  }, [videos]);


  const handlePlay = (vimeoLink) => {
    window.open(vimeoLink, '_blank');
  };

  const languageDescription = (item) => {
    // Retorna el nombre del idioma basado en el valor de 'item'
    if (item === "es") {
      return "Español";
    } else if (item === "en") {
      return "Inglés";
    } else if (item === "fr") {
      return "Francés";
    } else if (item === "it") {
      return "Italiano";
    } else if (item === "pt") {
      return "Portugués";
    }
    return "Idioma no disponible";  // En caso de que no se encuentre el idioma
  };


  const moduleDescription = (item) => {
    if (item === "0") {
      return "Modulo 0 (Bienvenidas, Intermedio, Despedidas, otros)";
    } else if (item === "1") {
      return "Modulo 1 Seguridad en cryptos";
    } else if (item === "2") {
      return "Modulo 2 Coinbase";
    } else if (item === "3") {
      return "Modulo 3 Bybit";
    } else if (item === "4") {
      return "Modulo 4 Binance";
    } else if (item === "5") {
      return "Modulo 5 Exchanges";
    } else if (item === "6") {
      return "Modulo 6 Herramientas Basicas";
    } else if (item === "7") {
      return "Modulo 7 Rabby Wallet";
    } else if (item === "8") {
      return "Modulo 8 Billetera Phantom";
    } else if (item === "9") {
      return "Modulo 9 Trezor";
    } else if (item === "10") {
      return "Modulo 10 Ledger";
    } else if (item === "11") {
      return "Modulo 11 Herramientas Onchain";
    } else if (item === "12") {
      return "Modulo 12 Analisis OnChain";
    } else if (item === "13") {
      return "Modulo 13 GMGN";
    } else if (item === "14") {
      return "Modulo 14 Dexscreener Avanzado";
    } else if (item === "15") {
      return "Modulo 15 Bot Bull x NEO";
    }
    return "Módulo no disponible";  // En caso de que no se encuentre el módulo
  };


  return (
    <div className="container mx-auto h-auto flex flex-col lg:flex-row gap-4 p-4">
      <div className="flex flex-col lg:flex-row gap-4 p-4 h-auto w-full lg:w-1/2 ">
        <div className="relative overflow-x-auto w-full">
          <div className="video-list">
            {Object.keys(groupedByLanguage).map((language) => (
              <div key={language} className="language-group mb-4">
                <h2 className="text-xl font-semibold text-white">{languageDescription(language)}</h2>
                {Object.keys(groupedByLanguage[language]).map((type) => (
                  <div key={type} className="type-group mb-4">
                    <button
                      className="w-full text-lg font-semibold py-2 px-4 bg-gray-800 text-white rounded-lg mb-2"
                      onClick={() => toggleGroup(`${language}-${type}`)}
                    >
                      {type.charAt(0).toUpperCase() + type.slice(1)}
                    </button>
                    <div
                      className={`transition-all duration-300 ease-in-out overflow-hidden ${expandedGroups[`${language}-${type}`] ? 'max-h-screen' : 'max-h-0'
                        }`}
                    >
                      <div className="video-items pl-6 pb-4">
                        {Object.keys(groupedByLanguage[language][type]).map((module) => (
                          <div key={module} className="module-group mb-4">
                            <button
                              className="w-full text-lg font-semibold py-2 px-4 bg-gray-700 text-white rounded-lg mb-2"
                              onClick={() => toggleGroup(`${language}-${type}-${module}`)}
                            >
                              {module === 'Sin módulo' ? 'Sin módulo' : moduleDescription(module)}
                            </button>

                            <div
                              className={`transition-all duration-300 ease-in-out overflow-hidden ${expandedGroups[`${language}-${type}-${module}`] ? 'max-h-screen' : 'max-h-0'
                                }`}
                            >
                              <div className="video-items pl-6 pb-4 ">
                                {Array.isArray(groupedByLanguage[language][type][module]) &&
                                  groupedByLanguage[language][type][module].map((video) => (
                                    <div key={video.id} className="video-item mb-4 flex flex-row gap-4 items-center">
                                      <p className="text-white">{video.name}</p>
                                      <button
                                        onClick={() => handlePlay(video.vimeo)}
                                        className="text-white bg-blue-500 hover:bg-blue-700 px-4 py-2 rounded-lg"
                                      >
                                        Play
                                      </button>
                                    </div>
                                  ))}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="w-full lg:w-1/2  text-white p-4 bg-zinc-800 text-white p-6 rounded-lg border-lime-600 hover:border-lime-300 border-2">
        <form onSubmit={handleSubmit(onSubmit)}>
          {/* Campo de Imagen 
          <div className="mb-4">
            <label className="block text-white mb-2" htmlFor="image">
              Imagen
            </label>
            <input
              type="file"
              id="image"
              onChange={handleFileChange}
              className="bg-gray-900 border-gladiaverse border text-white sm:text-sm rounded-full block w-full p-2.5 pl-4"
            />
          </div>
*/}
          {/* Campo de Tipo */}
          <div className="mb-4">
            <label className="block text-white mb-2" htmlFor="type">
              Tipo
            </label>
            <select
              id="type"
              {...register('type', { required: true })}
              className="bg-gray-900 border-gladiaverse border text-white sm:text-sm rounded-full block w-full p-2.5 pl-4"
            >
              <option value="basic" className='bg-gray-800 text-white'>Basico</option>
              <option value="intermediate" className='bg-gray-800 text-white'>Intermedio</option>
              <option value="advanced" className='bg-gray-800 text-white'>Avanzado</option>
            </select>
          </div>

          {/* Campo de Módulo */}
          <div className="mb-4">
            <label className="block text-white mb-2" htmlFor="module">
              Módulo
            </label>
            <select
              id="module"
              {...register('module', { required: true })}
              className="bg-gray-900 border-gladiaverse border text-white sm:text-sm rounded-full block w-full p-2.5 pl-4"
            >
              <option value="0" className='bg-gray-800 text-white'>Modulo 0 (Bienvenidas, Intermedio, Despedidas, otros)</option>
              <option value="1" className='bg-gray-800 text-white'>Modulo 1 Seguridad en cryptos</option>
              <option value="2" className='bg-gray-800 text-white'>Modulo 2 Coinbase</option>
              <option value="3" className='bg-gray-800 text-white'>Modulo 3 Bybit</option>
              <option value="4" className='bg-gray-800 text-white'>Modulo 4 Binance</option>
              <option value="5" className='bg-gray-800 text-white'>Modulo 5 Exchanges</option>
              <option value="6" className='bg-gray-800 text-white'>Modulo 6 Herramientas Basicas</option>
              <option value="7" className='bg-gray-800 text-white'>Modulo 7 Rabby Wallet</option>
              <option value="8" className='bg-gray-800 text-white'>Modulo 8 Billetera Phantom</option>
              <option value="9" className='bg-gray-800 text-white'>Modulo 9 Trezor</option>
              <option value="10" className='bg-gray-800 text-white'>Modulo 10 Ledger</option>
              <option value="11" className='bg-gray-800 text-white'>Modulo 11 Herramientas Onchain</option>
              <option value="12" className='bg-gray-800 text-white'>Modulo 12 Analisis OnChain</option>
              <option value="13" className='bg-gray-800 text-white'>Modulo 13 GMGN</option>
              <option value="14" className='bg-gray-800 text-white'>Modulo 14 Dexscreener Avanzado</option>
              <option value="15" className='bg-gray-800 text-white'>Modulo 15 Bot Bull x NEO</option>
            </select>
          </div>

          {/* Campo de Vimeo */}
          <div className="mb-4">
            <label className="block text-white mb-2" htmlFor="vimeo">
              Vimeo
            </label>
            <input
              type="text"
              id="vimeo"
              {...register('vimeo', { required: true })}
              placeholder="https://vimeo.com/1066087559/6f01a817ae"
              className="bg-gray-900 border-gladiaverse border text-white sm:text-sm rounded-full block w-full p-2.5 pl-4"
            />
          </div>

          {/* Campo de Nombre */}
          <div className="mb-4">
            <label className="block text-white mb-2" htmlFor="name">
              Nombre
            </label>
            <input
              type="text"
              id="name"
              {...register('name', { required: true })}
              placeholder="Escribe el nombre"
              className="bg-gray-900 border-gladiaverse border text-white sm:text-sm rounded-full block w-full p-2.5 pl-4"
            />
          </div>

          {/* Campo de Descripción */}
          <div className="mb-4">
            <label className="block text-white mb-2" htmlFor="description">
              Descripción
            </label>
            <textarea
              id="description"
              {...register('description')}
              placeholder="Escribe la descripción"
              className="bg-gray-900 border-gladiaverse border text-white sm:text-sm rounded-lg block w-full p-2.5 pl-4"
            />
          </div>

          {/* Campo de Idioma */}
          <div className="mb-4">
            <label className="block text-white mb-2" htmlFor="language">
              Idioma
            </label>
            <select
              id="language"
              {...register('language', { required: true })}
              className="bg-gray-900 border-gladiaverse border text-white sm:text-sm rounded-full block w-full p-2.5 pl-4"
            >
              <option value="en" className='bg-gray-800 text-white'>Inglés</option>
              <option value="es" className='bg-gray-800 text-white'>Español</option>
              <option value="fr" className='bg-gray-800 text-white'>Francés</option>
              <option value="it" className='bg-gray-800 text-white'>Italiano</option>
              <option value="pt" className='bg-gray-800 text-white'>Portugués</option>
            </select>
          </div>

          {/* Botón de Guardar */}
          <div className="mb-4">
            <button
              type="submit"
              className={`text-md border-2 p-1 cursor-pointer rounded-lg w-full `}

            >
              Guardar Video
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminCTFlix;
